export default "__VITE_ASSET__XIxX9Tof__"